import * as React from 'react'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTrash} from '@fortawesome/free-solid-svg-icons'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'
import {Button} from '@frontrow/console/src/components/button'

import * as style from './delete-license-button-modal.module.scss'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type Props = {
  subjectDetail: string
  removeLicense: () => void
}

export default function DeleteLicenseButtonModal(props: Props): React.ReactElement {
  const {isOpen, open, close} = useModalForm()
  const {subjectDetail} = props

  const removeLicense = () => {
    props.removeLicense()
    close()
  }

  return (
    <React.Fragment>
      <Button
        style="link"
        title={`Delete ${subjectDetail} license`}
        dataTest="delete-license-button"
        addClass="rounded p-1.5 hover:bg-surface-hover"
        onClick={open}
      >
        <FontAwesomeIcon icon={faTrash} />
      </Button>
      <Dialog
        open={isOpen}
        onClose={close}
        backdrop={<div className={dialogStyles.backdrop} />}
        className={dialogStyles.dialog}
        portal
        unmountOnHide
        hideOnEscape
        hideOnInteractOutside={false}
      >
        <div className={dialogStyles.header}>
          <DialogHeading className={dialogStyles.title}>
            Delete {subjectDetail} License
          </DialogHeading>
          <DialogDismiss className={dialogStyles.closeButton}>
            <span aria-hidden="true">&times;</span>
          </DialogDismiss>
        </div>
        <div className={dialogStyles.footer}>
          <Button style="link" addClass={style.deleteLicenseButton} onClick={close}>
            Cancel
          </Button>
          <Button style="danger" addClass={style.deleteLicenseButton} onClick={removeLicense}>
            Delete License
          </Button>
        </div>
      </Dialog>
    </React.Fragment>
  )
}
